import axios from 'axios';

const baseUrl = 'https://www.googleapis.com/youtube/v3/';
const YT_API_KEY = process.env.GATSBY_YOUTUBE_DATA_API_KEY;

export const getVideoViews = async (videoId) => {
  try {
    const {
      data: {
        items: [
          {
            statistics: { viewCount },
          },
        ],
      },
    } = await axios({
      method: 'get',
      url: `${baseUrl}videos`,
      params: {
        part: 'statistics',
        id: videoId,
        key: YT_API_KEY,
      },
      timeout: 7000,
    });
    return viewCount;
  } catch (err) {
    return err;
  }
};

export const getChannelViews = async (channelId) => {
  try {
    const {
      data: {
        items: [
          {
            statistics: { viewCount },
          },
        ],
      },
    } = await axios({
      method: 'get',
      url: `${baseUrl}channels`,
      params: {
        part: 'statistics',
        id: channelId,
        key: YT_API_KEY,
      },
      timeout: 7000,
    });
    return viewCount;
  } catch (err) {
    return err;
  }
};

export const getPlaylistSortedByViews = async (playlistId) => {
  let episodeViews = [];
  let nextPageToken = '';
  while (true) {
    let playlistRes;
    try {
      playlistRes = await axios({
        method: 'get',
        url: `${baseUrl}playlistItems`,
        params: {
          part: 'contentDetails',
          playlistId: playlistId,
          maxResults: 50,
          pageToken: nextPageToken,
          key: YT_API_KEY,
        },
        timeout: 7000,
      });
    } catch (err) {
      break;
    }

    let videoIds = [];
    playlistRes.data.items.forEach((item) =>
      videoIds.push(item.contentDetails.videoId)
    );

    let vidRes;
    try {
      vidRes = await axios({
        method: 'get',
        url: `${baseUrl}videos`,
        params: {
          part: 'snippet,statistics',
          id: videoIds.join(','),
          key: YT_API_KEY,
        },
        timeout: 7000,
      });
    } catch (err) {
      break;
    }

    vidRes.data.items.forEach((item) => {
      let title = item.snippet.title;
      let views = item.statistics.viewCount;
      let id = title.split('#')[1];
      if (!id) {
        return;
      }
      episodeViews.push({ id: id, views });
    });

    nextPageToken = playlistRes.data.nextPageToken;
    if (!nextPageToken) break;
  }
  return episodeViews.sort((a, b) => b.views - a.views);
};
